import { updatePassword } from '../../../modules/auth/auth.repository';
import { UpdatePasswordPayload } from '../../../modules/auth/types';

export const setUpdatePasswordUseCase = (payload: UpdatePasswordPayload) => {
  return updatePassword(payload);
};
